import { HTMLAttributes } from 'react';

export enum IconColor {
  WHITE = '#FFFFFF',
  BLACK = '#000000',
  PRIMARY_BLUE = '#03BAF5',
  LOSE = '#E15D46',
  YELLOW = '#E1CD46',
  GREEN = '#39C074',
  DISABLED = '#533772',
  ORANGE = '#FF803C',
  BLUE = '#467FEB',
  VIOLET_COLOR = '#795D97',
  IRON_COLOR = '#DFDFDF',
  BRONZE_COLOR = '#794030',
  SILVER_COLOR = '#5E5E5E',
  GOLD_COLOR = '#74612D',
  WHITE_GOLD_COLOR = '#6E6038',
  PINK_GOLD_COLOR = '#815546',
  RED_GOLD_COLOR = '#7C5539',
  TEXT_PRIMARY = '#FFFFD7',
  BACKGROUND_PRIMARY = '#255144',
  BACKGROUND_SECONDARY = '#043023',
  TICKET_BACKGROUND = '#E3D2B9',
  TEXT_QUATERNARY = '#6C6C6E',
  TEXT_SECONDARY = '#669285',
  BET_TICKET_BORDER = '#B0925D',
}

export interface IconProps extends HTMLAttributes<SVGElement> {
  width?: number;
  height?: number;
  disabled?: boolean;
  fillColor?: IconColor;
  fillColor_2?: IconColor;
  fillColor_3?: IconColor;
}
